import type { DocumentSection } from '@shared/types';

export interface ProposalGridChangeSet {
  changedIds: string[];
  addedIds: string[];
}

/**
 * Compares two deck snapshots. Added slides are reported separately, while
 * surrounding slides that only reflow because of an insertion stay unchanged.
 */
export function diffProposalSections(
  previous: DocumentSection[],
  next: DocumentSection[],
): ProposalGridChangeSet {
  const previousById = new Map(previous.map((section) => [section.id, section]));
  const changedIds: string[] = [];
  const addedIds: string[] = [];

  next.forEach((section) => {
    const prior = previousById.get(section.id);
    if (!prior) {
      addedIds.push(section.id);
      return;
    }
    if (JSON.stringify(prior) !== JSON.stringify(section)) {
      changedIds.push(section.id);
    }
  });

  return { changedIds, addedIds };
}

export function hasProposalGridChanges(changeSet: ProposalGridChangeSet): boolean {
  return changeSet.changedIds.length + changeSet.addedIds.length > 0;
}

export function proposalGridChangeLabel(changeSet: ProposalGridChangeSet): string {
  const parts: string[] = [];
  if (changeSet.changedIds.length > 0) {
    parts.push(`${changeSet.changedIds.length} ${changeSet.changedIds.length === 1 ? 'page' : 'pages'} changed`);
  }
  if (changeSet.addedIds.length > 0) {
    parts.push(`${changeSet.addedIds.length} ${changeSet.addedIds.length === 1 ? 'page' : 'pages'} added`);
  }
  return parts.join(' · ');
}
